import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSSEStream } from '../../hooks/useSSEStream';
import { INTERACTIVE_SERVICE_BASE_URL } from '../constants';
import { SSE_COMPLETION_EVENTS } from '../hooks/useChat';

const StreamMonitor = ({ sessionKey, runId, onMessage, onError }) => {
    const handleMessage = useCallback(
        message => onMessage(sessionKey, message),
        [sessionKey, onMessage]
    );

    const { error } = useSSEStream(INTERACTIVE_SERVICE_BASE_URL, runId, handleMessage, SSE_COMPLETION_EVENTS);

    useEffect(() => {
        if (error) onError(sessionKey, error);
    }, [error, sessionKey, onError]);

    return null;
};

StreamMonitor.propTypes = {
    sessionKey: PropTypes.string.isRequired,
    runId: PropTypes.string.isRequired,
    onMessage: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
};

export default StreamMonitor;
